import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function _6kPlusIcon(props: IconProps) {
    return <Icon {...props} iconKey={"6k_plus"}/>
}
